import { useState } from "react"
import { graphQueryBang, gql } from "shared/lib/graphql"
import UpgradeToProModal from "./upgrade_to_pro_modal"
import CheckoutModal from "./upgrade_to_pro_modal/checkout_modal"
import UpgradePlanModal from "./upgrade_plan_modal"

interface Props {
  user: object
  eligibleForTrial: boolean
  proPlusProductId: string
  serviceName: string
  subscriptionPaymentType: string
  isTrialing: boolean
  urls: { [key: string]: string }
}

const GatedServiceAuthButton = ({
  user,
  eligibleForTrial,
  proPlusProductId,
  serviceName,
  subscriptionPaymentType,
  isTrialing,
  urls: { redirectToConnect, newProSubscriptionUrl, modalSubscriptionUrl },
}: Props) => {
  const [showModal, setShowModal] = useState(false)
  const [showCheckoutModal, updateCheckoutModalVisibility] = useState(false)

  const onUpgrade = () => {
    graphQueryBang(userQuery, {}).then((res: { me: { tier: string } }) => {
      if (res.me.tier !== "free") {
        connect()
      }
    })
  }

  const connect = () => (window.location = redirectToConnect)

  return (
    <>
      {window.App.newCheckoutModal ? (
        <UpgradePlanModal
          onClose={() => setShowModal(false)}
          onUpgrade={onUpgrade}
          premiumService={serviceName}
          proPlusProductId={proPlusProductId}
          urls={{
            newProSubscriptionUrl,
            modalSubscriptionUrl,
          }}
          step="pro_service_tqas"
          tierRequirement="intermediate_pro"
          trackLocationType="service"
          user={{
            eligibleForTrial,
            isTrialing,
            subscriptionPaymentType,
            tier: user.tier,
          }}
          visible={showModal}
        />
      ) : (
        <>
          <UpgradeToProModal
            visible={showModal}
            step="pro_service_tqas"
            tierRequirement="intermediate_pro"
            premiumService={serviceName}
            onUpgrade={onUpgrade}
            showCheckoutModal={() => updateCheckoutModalVisibility(true)}
            onClose={() => setShowModal(false)}
            eligibleForTrial={eligibleForTrial}
            currentTier={user.tier}
            subscriptionPaymentType={subscriptionPaymentType}
            proPlusProductId={proPlusProductId}
            isTrialing={isTrialing}
            trackLocationType="service"
          />
          <CheckoutModal
            visible={showCheckoutModal}
            target={"intermediate_pro"}
            onClose={() => updateCheckoutModalVisibility(false)}
            onUpgrade={onUpgrade}
            locationType="services"
            newProSubscriptionUrl={newProSubscriptionUrl}
            modalSubscriptionUrl={modalSubscriptionUrl}
          />
        </>
      )}
      <a
        href="#"
        onClick={() => setShowModal(true)}
        className="button-secondary button-on-color"
        data-turbolinks="false"
        title="Connect"
      >
        Connect
      </a>
    </>
  )
}

const userQuery = gql`
  query {
    me {
      tier
    }
  }
`

export default GatedServiceAuthButton
